<plotly-plot class="mat-elevation-z6" [data]="plotly_heatmap" [layout]="plotly_heatmap.layout" [useResizeHandler]="true" [style]="{width: '100%', height: '100%'}"></plotly-plot>
